<template>
  <div>
    <intro id="intro"></intro>
    <about-us id="about"></about-us>
    <product-list id="product"></product-list>
    <mask-pro></mask-pro>
    <contact-us id="contact"></contact-us>
  </div>
</template>
<script>
import Intro from "./components/IndexComponents/Intro";
import AboutUs from "./components/IndexComponents/AboutUs";
import ProductList from "./components/IndexComponents/ProductList";
import MaskPro from "./components/IndexComponents/MaskPro";
import ContactUs from "./components/IndexComponents/ContactUs";

export default {
  name: "index",
  components: {
    Intro,
    AboutUs,
    ProductList,
    MaskPro,
    ContactUs
  },
};
</script>
